export function lessonPlayback(lesson, apiUrl) {
  const original = lesson.video?.url || lesson.recording?.finalVideo?.url;
  const key = lesson.video?.key || lesson.recording?.finalVideo?.key;
  const hls = lesson.hls;
  const version = hls?.prefix?.split("/").filter(Boolean).at(-1);
  if (hls?.status === "ready" && key && hls.sourceKey === key && /^[a-f\d-]{36}$/i.test(version || "")) {
    return { src: `${apiUrl.replace(/\/$/, "")}/api/classes/${lesson._id}/hls/${version}/master.m3u8`, progressSource: original, mimeType: "application/x-mpegURL", renditions: hls.renditions || [] };
  }
  return { src: undefined, progressSource: original, processing: Boolean(key || original) && hls?.status !== "failed", failed: hls?.status === "failed" };
}
